import axios from 'axios';

// Enable sending cookies with requests
axios.defaults.withCredentials = true;

// Tell Axios the cookie and header names Django uses for CSRF
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';

// Utility to extract CSRF token from cookies
function getCSRFToken() {
  const cookieValue = document.cookie.split('; ').find(row => row.startsWith('csrftoken='));
  return cookieValue ? cookieValue.split('=')[1] : '';
}

// Add CSRF token header on unsafe HTTP methods before sending
axios.interceptors.request.use(config => {
  if (['post', 'put', 'patch', 'delete'].includes(config.method)) {
    config.headers['X-CSRFToken'] = getCSRFToken();
  }
  return config;
});

export default axios;
